import React from 'react'
import { Image } from '@chakra-ui/react'
import { Box, Text, Link, AspectRatio } from '@chakra-ui/react'

import { useUserContext } from '~config/user-context'
import SharedStack from '~components/shared/wrappers/shared-stack'
import {
    ClinicFieldsFragment,
    ClinicGroupFieldsFragment,
    OrganizationFieldsFragment,
} from '~graphql/generated/graphql'
import MenuItem from '~components/shared/menu/menu-item'
import {
    BiBuildingHouse,
    BiCopy,
    BiLinkExternal,
    BiRefresh,
} from 'react-icons/bi'
import { navigate } from 'gatsby'
import { UserRoutes } from '~config/routes'
import { Icon, MenuGroup } from '@chakra-ui/react'
import { getSupabaseLink, SupabaseEntities } from '~config/constants'

interface Props {
    clinicGroup: ClinicGroupFieldsFragment
    setClinicGroup: (e: ClinicGroupFieldsFragment | undefined) => void
    setClinic: (e: ClinicFieldsFragment | undefined) => void
    canSwitch?: boolean
}

export default function ClinicGroupOptions({
    clinicGroup,
    setClinicGroup,
    setClinic,
    canSwitch = true,
}: Props) {
    const { isAdmin } = useUserContext()

    return (
        <>
            <SharedStack row fit px={4} pt={1} spacing={4} mb={2}>
                <Box>
                    <Text fontSize="sm" fontWeight="semibold">
                        {clinicGroup.name}
                    </Text>
                </Box>
            </SharedStack>
            {(canSwitch || isAdmin) && (
                <MenuItem
                    icon={BiRefresh}
                    onClick={() => {
                        setClinicGroup(undefined)
                        setClinic(undefined)
                        navigate(UserRoutes.SelectClinic)
                    }}
                >
                    Switch Clinic Group
                </MenuItem>
            )}
            {isAdmin && (
                <MenuGroup title="Admin" fontSize="xs">
                    <MenuItem
                        icon={BiCopy}
                        onClick={() =>
                            navigator.clipboard.writeText(clinicGroup.id)
                        }
                    >
                        Copy Clinic Group ID
                    </MenuItem>
                </MenuGroup>
            )}
        </>
    )
}
